import type { AxiosError } from 'axios';

export type IApiError = {
  message: string;
  code?: string;
  status?: number;
  requestId?: string;
  raw?: unknown;
};

export function extractErrorMessage(err: unknown, fallback = 'Ett fel inträffade'): string {
  // AxiosError with response data
  const ax = err as AxiosError<any>;
  const data = ax?.response?.data as any;

  // Common fields from upstream/backends
  const candidates: Array<string | undefined> = [
    data?.errorMessage,
    data?.message,
    data?.detail,
    data?.title,
    (Array.isArray(data) ? data.join(', ') : undefined),
    (typeof data === 'string' ? data : undefined),
    (ax?.message ?? undefined),
  ];

  const found = candidates.find((c) => !!c && typeof c === 'string' && c.trim().length > 0);
  if (found) return found as string;

  // Generic
  return fallback;
}

export function toApiError(err: unknown): IApiError {
  const ax = err as AxiosError<any>;
  const status = ax?.response?.status;
  const data = ax?.response?.data as any;
  const requestId = (data && typeof data === 'object' && data.requestId) || undefined;

  return {
    message: extractErrorMessage(err),
    status,
    requestId,
    raw: data ?? err,
  };
}
